import { render, staticRenderFns } from "./classSearChList.vue?vue&type=template&id=5f0dd95e&scoped=true"
import script from "./classSearChList.vue?vue&type=script&lang=js"
export * from "./classSearChList.vue?vue&type=script&lang=js"
import style0 from "./classSearChList.vue?vue&type=style&index=0&id=5f0dd95e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0dd95e",
  null
  
)

export default component.exports